import camelcaseKeys from 'camelcase-keys'

export class ActivityReservationLog {
  constructor (params = {}) {
    const {
      id,
      created,
      attributes,
      tag,
    } = camelcaseKeys(params)
    const {
      previous,
      current,
      initiator,
      webappUserCredentialId,
      order,
      paymentGatewayId,
      success,
      paymentTransactionId,
    } = camelcaseKeys(attributes)
    this.id = id || null
    this.tag = tag || null
    this.created = new Date(created)
    this.previous = previous ? JSON.parse(previous) : null
    this.current = current ? JSON.parse(current) : null
    this.initiator = initiator || null
    this.webappUserCredentialId = webappUserCredentialId || null
    this.order = order ? JSON.parse(order) : null
    this.paymentGatewayId = paymentGatewayId || null
    this.success = success || null
    this.paymentTransactionId = paymentTransactionId || null
  }
}
